export default () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="currentColor" />
    <path
      d="M8.26557 11.8958L6.47149 10.1017C6.20059 9.83079 5.76139 9.83079 5.4905 10.1017C5.2196 10.3726 5.2196 10.8118 5.49049 11.0827L7.72131 13.3135C8.0219 13.6141 8.50925 13.6141 8.80984 13.3135L14.5095 7.61382C14.7804 7.34293 14.7804 6.90372 14.5095 6.63283C14.2386 6.36194 13.7994 6.36194 13.5285 6.63283L8.26557 11.8958Z"
      fill="white"
    />
  </svg>
);
